import React from "react";
import { Typography, Chip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { EstadoBadge } from "../components/ui";
import { DATA_GRID_FONT_SIZE } from "../../../components/ui/dataGridStyles";
import { TRASPASO_ESTADO } from "../constants";

/**
 * Columnas del DataGrid de traspasos entre almacenes
 */
export const generateTraspasoColumns = ({ onVerDetalle, onEditar, onConfirmarEstado }) => [

            {
                field: "id",
                headerName: "ID",
                width: 90,
                renderCell: (params) => (
                    <Typography sx={{ fontWeight: 600, fontSize: DATA_GRID_FONT_SIZE.CELDA }}>
                        #{params.value}
                    </Typography>
                ),
            },
            {
                field: "fecha",
                headerName: "Fecha",
                width: 130,
                valueGetter: (p) => (p.row.fecha ? String(p.row.fecha).slice(0, 10) : ""),
            },
            {
                field: "almacenOrigenNombre",
                headerName: "Origen",
                flex: 1,
                minWidth: 160
            },
            {
                field: "almacenDestinoNombre",
                headerName: "Destino",
                flex: 1,
                minWidth: 160
            },
            {
                field: "empleadoOrigenNombre",
                headerName: "Emp. origen",
                flex: 1,
                minWidth: 180
            },
            {
                field: "empleadoDestinoNombre",
                headerName: "Emp. destino",
                flex: 1,
                minWidth: 180
            },
            {
                field: "totalLineas",
                headerName: "Líneas",
                width: 90,
                type: "number",
                align: "center",
                headerAlign: "center",
                valueGetter: (p) => p.row.totalLineas ?? p.row.lineasCount ?? 0,
                renderCell: (params) => (
                    <Chip
                        label={params.value}
                        size="small"
                        sx={{
                            height: 24,
                            fontSize: 11,
                            fontWeight: 600,
                            backgroundColor: "#f8f9fa",
                            color: "#495057",
                        }}
                    />
                ),
            },
            {
                field: "totalUnidades",
                headerName: "Unidades",
                width: 130,
                type: "number",
                align: "center",
                headerAlign: "center",
                valueGetter: (p) => p.row.totalUnidades ?? 0,
                renderCell: (params) => (
                    <Chip
                        label={params.value}
                        size="small"
                        sx={{
                            height: 24,
                            fontSize: 11,
                            fontWeight: 600,
                            backgroundColor: "#f8f9fa",
                            color: "#495057",
                        }}
                    />
                ),
            },
            {
                field: "estado",
                headerName: "Estado",
                width: 140,
                renderCell: (params) => <EstadoBadge estado={(params.row.estado ?? "").toUpperCase()} />,
            },
            {
                field: "acciones",
                type: "actions",
                headerName: "Acciones",
                width: 140,
                sortable: false,
                filterable: false,
                getActions: (params) => {
                    const isTraspasado = (params.row.estado ?? "").toUpperCase() === TRASPASO_ESTADO.TRASPASADO;

                    const actions = [
                        <GridActionsCellItem
                            key="ver"
                            icon={<VisibilityIcon />}
                            label="Ver detalle"
                            onClick={() => onVerDetalle(params.row)}
                            sx={{ color: "#6c757d" }}
                            showInMenu={false}
                        />
                    ];

                    if (!isTraspasado) {
                        actions.push(
                            <GridActionsCellItem
                                key="editar"
                                icon={<EditIcon />}
                                label="Editar"
                                onClick={() => onEditar(params.row)}
                                sx={{ color: "#495057" }}
                                showInMenu={false}
                            />,
                            <GridActionsCellItem
                                key="traspasar"
                                icon={<TaskAltIcon />}
                                label="Marcar traspasado"
                                onClick={() => onConfirmarEstado(params.row)}
                                color="success"
                                showInMenu={false}
                            />
                        );
                    }

                    return actions;
                },
            },
];
